import {useState, useEffect} from "react";
import {useParams, useSearchParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";
import {CrossView} from "./CrossView";

// С5 — ДЗ кръстосана за землище ИЛИ община (Г3 §2).
// scopeType: "settlement" | "municipality"; scope: ekatte или име на община.
// Е8: опционален филтър ?bullstat= (само замените на този ползвател).
// Ъ2: таблиците живеят в CrossView — същите ги показва и публичният линк.
export const ReportCross = () => {
    const {year, scopeType, scope} = useParams();
    const [searchParams] = useSearchParams();
    const bullstat = searchParams.get('bullstat');
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const request = requester();

    const query = `${scopeType}=${encodeURIComponent(scope)}`
        + (bullstat ? `&bullstat=${encodeURIComponent(bullstat)}` : '');

    useEffect(() => {
        request.get(`${baseUrl()}/reports/cross/${year}?${query}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [year, scopeType, scope, bullstat]);

    const handlePdf = () => {
        downloadPdf(`/reports/cross/${year}?${query}&format=pdf`, `S5cross_${scope}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const scopeLabel = data.scope.type === "settlement"
        ? `Землище: ${data.scope.name}`
        : `Община: ${data.scope.name}`;

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>С5 — ДЗ кръстосана</h5>
                    <div>{scopeLabel}</div>
                    <div>Стопанска {data.year} година | {data.date}</div>
                </div>
                <button className="btn btn-outline-danger" onClick={handlePdf}>PDF</button>
            </div>

            <CrossView data={data}/>
        </div>
    );
};
